import { ShaderChunk } from './ShaderChunk';
import THREE from '../utils/threeClassesAdapter';

const Uniforms = {
    twoColorGradient: {
        color0: { type: 'c', value: new THREE.Color(0x000000) },
        color1: { type: 'c', value: new THREE.Color(0xffffff) },
        rotate: { type: 'f', value: 0 },
        ratio0: { type: 'f', value: 0 },
        ratio1: { type: 'f', value: 1 },
        fixChubb: { value: false }
    },
    opacity: {
        opacity: { type: 'f', value: 1 }
    },
    aspectProgress: {
        progress: { type: 'f', value: 0 },
        aspect: { type: 'f', value: 1 }
    },
    fog: {
        fogColor: { type: 'c', value: new THREE.Color(0x000000) },
        fogNear: { type: 'f', value: 50 },
        fogFar: { type: 'f', value: 80 }
    },
    resolution: {
        uResolution: { value: new THREE.Vector2(100, 100) }
    },
    time: {
        time: { value: 0 }
    }
};

export const ShaderLib = {
    gradientBackground: {
        uniforms: THREE.UniformsUtils.merge([
            Uniforms.twoColorGradient,
            Uniforms.resolution,
            Uniforms.aspectProgress
        ]),

        vertexShader: ShaderChunk.minimal_vert,
        fragmentShader: ShaderChunk.gradientbackground_frag
    },
    flagMatcap: {
        uniforms: THREE.UniformsUtils.merge([
            THREE.ShaderLib.matcap.uniforms,
            Uniforms.time
        ]),

        vertexShader: ShaderChunk.flag_meshmatcap_vert,
        fragmentShader: ShaderChunk.flag_meshmatcap_frag
    },
    testUv: {
        vertexShader: ShaderChunk.minimal_uv_vert,
        fragmentShader: ShaderChunk.test_uv_frag
    }
};
